import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    // color: 'black',
    color: theme.palette.common.white,
    // textWrap: 'nowrap',
    // marginTop: theme.spacing(9),
    fontFamily: 'Brilliant Cut Pro',
    fontWeight: 500,
    fontSize: 28,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  subtitle: {
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: 40,
    fontFamily: 'Baskerville',
    lineHeight: '100%',
    letterSpacing: '0%',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      marginBottom: theme.spacing(6),
    },
  },
  logo: {
    maxWidth: 275,
  },
}));

const EventTitle = ({ showLogo }) => {
  const classes = useStyles();
  return (
    <div className={classes.content}>
      <img
        src="https://cdn.eventtia.com/event_files/231692/original/cwi-20-years-logo-white-result.png?1773767652"
        alt="cartier-logo"
        className={classes.logo}
      />
      <div>
        <Typography
          variant="h1"
          className={classes.title}
        >
          2026 AWARDS WEEK
          <br />
          BANGKOK, THAILAND
          <br />
          JUNE 2026
        </Typography>
      </div>
      {showLogo && (
        <div>
          {/* <img
            src="https://cdn.eventtia.com/event_files/208491/original/logo.svg?1742931147"
            alt="Van Cleef Logo"
            className={classes.logo}
          /> */}
        </div>
      )}
    </div>
  );
};

EventTitle.propTypes = {
  showLogo: PropTypes.bool,
};

EventTitle.defaultProps = {
  showLogo: true,
};

export default EventTitle;
